import React from 'react';
import { StakeholderType } from '@sonar-software/sonar-core';
import { Tag } from 'antd';

export interface StakeholderTypeDisplayProps {
	type: StakeholderType;
}

export const StakeholderTypeDisplay: React.FC<StakeholderTypeDisplayProps> = ({ type }) => {
	const color = type === StakeholderType.Individual ? 'geekblue' : 'orange';

	return <Tag color={ color }>{ type }</Tag>;
};
